import { memo } from "react";
// @mui
import { styled } from "@mui/material/styles";
import { Container, AppBar } from "@mui/material";
// config
import { HEADER } from "../../../config";
import useAuth from "../../../hooks/useAuth";
// components
import SvgIconStyle from "../../../components/SvgIconStyle";
import { NavSectionHorizontal } from "../../../components/nav-section";
import PartnerNavConfig from "./PartnerNavConfig";
import { useTranslation } from "react-i18next";

// ----------------------------------------------------------------------
const getIcon = (name) => (
  <SvgIconStyle
    src={`/static/icons/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  collectif: getIcon("ic_collectif"),
  multi: getIcon("ic_versus"),
  challenge: getIcon("ic_challenge"),
  friends: getIcon("ic_friends"),
  quiz_friend: getIcon("ic_quiz_friend"),
  bet: getIcon("ic_bet"),
  cart: getIcon("ic_cart"),
  chat: getIcon("ic_chat"),
  mail: getIcon("ic_mail"),
  user: getIcon("ic_user"),
  users: getIcon("ic_users"),
  dashboard: getIcon("ic_dashboard"),
  question: getIcon("ic_ideas"),
};

const RootStyle = styled(AppBar)(({ theme }) => ({
  transition: theme.transitions.create("top", {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  width: "100%",
  position: "fixed",
  zIndex: theme.zIndex.appBar,
  padding: theme.spacing(1, 0),
  boxShadow: theme.customShadows.z8,
  top: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

function NavbarHorizontal() {
  const { t } = useTranslation();

  const { user } = useAuth();

  return (
    <RootStyle>
      <Container maxWidth={false}>
        <NavSectionHorizontal
          permissions_list={user?.user_permissions_list}
          navConfig={PartnerNavConfig()}
        />
      </Container>
    </RootStyle>
  );
}

export default memo(NavbarHorizontal);
